export default __webpack_public_path__ + "static/media/banner2.ba9dcef1.png";